import {NgModule} from '@angular/core';
import {EquipmentViewLayoutComponent} from './equipment-view-layout/equipment-view-layout.component';
import {EquipmentViewCommonComponent} from './equipment-view-common/equipment-view-common.component';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '@layoutComponents/layout.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {EquipmentDataFlowService} from './services/equipment-data-flow.service';
import {ModalModule} from '@components/modal/modal.module';
import {FilePreviewModule} from '@components/file-preview/file-preview.module';
import {TabsModule} from '@components/tabs/tabs.module';
import {EquipmentViewTabCalibrationsComponent} from './equipment-view-tab-calibrations/equipment-view-tab-calibrations.component';
import {CountEditComponent} from './components/count-edit.component';
import {CountEditService} from './services/count-edit.service';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {CalibrationPreviewComponent} from './components/calibration-preview.component';
import {PipesModule} from '@pipes/pipes.module';
import {RouterModule} from '@angular/router';
import {WorkingObjectsListComponent} from './components/working-objects-list/working-objects-list.component';
import {EquipmentViewTabRepairsComponent} from '@modules/equipment-view/equipment-view-tab-repairs/equipment-view-tab-repairs.component';
import {IconsModule} from '@lab365/icons';
import {Lab365CommonModule} from '@lab365/common';


@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        DirectivesModule,
        ModalModule,
        FilePreviewModule,
        TabsModule,
        ReactiveFormsModule,
        FormFieldModule,
        PipesModule,
        RouterModule,
        IconsModule,
        Lab365CommonModule,
    ],
    exports: [
        EquipmentViewLayoutComponent,
    ],
    declarations: [
        EquipmentViewLayoutComponent,
        EquipmentViewCommonComponent,
        EquipmentViewTabCalibrationsComponent,
        CountEditComponent,
        CalibrationPreviewComponent,
        WorkingObjectsListComponent,
        EquipmentViewTabRepairsComponent,
    ],
    providers: [
        EquipmentDataFlowService,
        CountEditService,
    ],
})
export class EquipmentViewModule {
}
